import appointments from "./appointments.json" with { type: "json" }
import auth from "./auth.json" with { type: "json" }
import common from "./common.json" with { type: "json" }
import cookie_banner from "./cookie_banner.json" with { type: "json" }
import dashboard from "./dashboard.json" with { type: "json" }
import exams from "./exams.json" with { type: "json" }
import form from "./form.json" with { type: "json" }
import navigation from "./navigation.json" with { type: "json" }
import notifications from "./notifications.json" with { type: "json" }
import offices from "./offices.json" with { type: "json" }
import open from "./open.json" with { type: "json" }
import patients from "./patients.json" with { type: "json" }
import pregnancies from "./pregnancies.json" with { type: "json" }
import profile from "./profile.json" with { type: "json" }
import secretaries from "./secretaries.json" with { type: "json" }
import therapies from "./therapies.json" with { type: "json" }
import visits from "./visits.json" with { type: "json" }

export default {
	common,
	auth,
	cookie_banner,
	appointments,
	dashboard,
	navigation,
	notifications,
	form,
	offices,
	open,
	secretaries,
	exams,
	patients,
	pregnancies,
	therapies,
	visits,
	profile
}
